<!-- <h1 class="mb-5">Listing Preview</h1> -->
<div id="splash-screen" class="splash-screen" *ngIf="IsLoading">
  <img src="./assets/media/logos/prophero-small.svg" alt="PropHero logo" />
  <span>Loading ...</span>
</div>
<div class="card mb-5" *ngIf="displayView">
  <div class="card-body">
    <div class="d-flex justify-content-between">
     <span class="fs-2 text-dark fw-bolder pt-5 mt-5">{{previewData?.companyName}}</span>
      <img *ngIf="companyImagePath != null" src="{{companyImagePath}}" alt="Company Logo" height="80" class="object-fit-contain" />
    </div>
    <hr />
    <h2 class="text-primary">
      {{ previewData?.bedsName }} {{ previewData?.propertytypeName }} in
      {{ previewData?.subLocationName
      }}<span *ngIf="previewData?.subLocationName != null">,</span>
      {{ previewData?.locationName
      }}<span *ngIf="previewData?.locationName != null">,</span>
      {{ previewData?.emiratesName }} (Ref: <b>{{ previewData?.reference }}</b
      >)
    </h2>
    <span class="badge badge-light-success me-auto mb-2 fs-4"
      >For {{ previewData?.purposeName }}</span
    >
    <span *ngIf="previewData?.purposeId == 1" class="badge badge-success me-auto mb-2 fs-4 ms-4"
      >{{previewData?.price}}  {{companySettings?.currency}}</span
    >

    <span *ngIf="previewData?.purposeId == 2" class="badge badge-success me-auto mb-2 fs-4 ms-4"
      >{{previewData?.price}}  {{companySettings?.currency}} {{previewData?.frequencyname}}  <span *ngIf="previewData?.checqueName != null"> &nbsp;in {{previewData?.checqueName}}</span>  </span
    >

    <ul class="d-flex gap-6 list-style-none p-0 text-gray-700 mb-4 fs-5">
      <li *ngIf="previewData?.propertytypeName != null">
        <small class="fw-semibold text-muted">Category</small><br />
        <b class="fw-bold fs-6 text-gray-800">{{
          previewData?.propertytypeName
        }}</b>
      </li>

      <li *ngIf="previewData?.bedsName != null">
        <small class="fw-semibold text-muted">Beds</small><br />
        <b class="fw-bold fs-6 text-gray-800">{{ previewData?.bedsName }}</b>
      </li>

      <li *ngIf="previewData?.bathsName != null">
        <small class="fw-semibold text-muted">Bath</small><br />
        <b class="fw-bold fs-6 text-gray-800">{{ previewData?.bathsName }}</b>
      </li>

      <li *ngIf="previewData?.plotArea != null">
        <small class="fw-semibold text-muted">Plot Area</small><br />
        <b class="fw-bold fs-6 text-gray-800"
          >{{ previewData?.plotArea }} {{ companySettings?.measuringUnit == '1'? 'Sq. Ft.':'Sq. M.' }}</b
        >
      </li>

      <li *ngIf="previewData?.buildUpArea != null">
        <small class="fw-semibold text-muted">Built-up Area</small><br />
        <b class="fw-bold fs-6 text-gray-800"
          >{{ previewData?.buildUpArea }} {{ companySettings?.measuringUnit == '1'? 'Sq. Ft.':'Sq. M.' }}</b
        >
      </li>

      <li *ngIf="previewData?.furnishedName != null">
        <small class="fw-semibold text-muted">Furnished</small><br />
        <b class="fw-bold fs-6 text-gray-800"
          >{{ previewData?.furnishedName }}</b
        >
      </li>
    </ul>

    <div class="row" *ngIf="photosdisplay != null">
      <div class="col-lg-6 mb-5">
        <img
          *ngIf="photosdisplay.length >= 1"
          src="{{ photosdisplay[0] }}"
          height="500"
          class="rounded w-100 object-fit-cover"
          (click)="openPhotosslider(0)"
        />
        
      </div>

      <div class="col-lg-6 mb-5" style="display: grid;grid-template-columns: repeat(2, 1fr);gap:20px">

        <div>
          <img
          *ngIf="photosdisplay.length >= 2"
            src="{{ photosdisplay[1] }}"
            height="240"
            class="rounded w-100 object-fit-cover"
            (click)="openPhotosslider(1)"
          />
        </div>
        <div>
          <img
          *ngIf="photosdisplay.length >= 3"
          src="{{ photosdisplay[2] }}"
          height="240"
          class="rounded w-100 object-fit-cover"
          (click)="openPhotosslider(2)"
        />
        </div>
        <div>
          <img
          *ngIf="photosdisplay.length >= 4"
          src="{{ photosdisplay[3] }}"
          height="240"
          class="rounded w-100 object-fit-cover"
          (click)="openPhotosslider(3)"
        />
        </div>
        <div>
          <img
          *ngIf="photosdisplay.length >= 5"
            src="{{ photosdisplay[4] }}"
            height="240"
            class="rounded w-100 object-fit-cover"
            (click)="openPhotosslider(4)"
          />
        </div>

        <!-- <img
          *ngIf="!display1stImage"
          src="{{listingDeafaultImage}}"
          height="240"
          class="rounded w-100 object-fit-cover"
          style="margin-bottom: 30px"
        />
        <img
          *ngIf="!display2ndImage"
          src="{{listingDeafaultImage}}"
          height="240"
          class="rounded w-100 object-fit-cover"
        /> -->
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 fs-5">
        <small class="fw-semibold text-muted" *ngIf="previewData?.title != null && previewData?.title != ''">Title</small>
        <p class="fs-4">
          <!-- Consider the limitless possibilities with our product team that has
          already tackled your cloud development obstacles. Seamlessly move more
          data and operations, reduce response times to a minimum cost, or scale
          your product for a large influx of new users. -->
          {{previewData?.title}}
        </p>
       
      </div>

      <div class="col-lg-12 fs-5">
        <small class="fw-semibold text-muted" *ngIf="previewData?.description != null && previewData?.description != ''">Description</small>
        <div class="fs-4 formatted-text mb-5" [innerHTML]="previewData?.description">
          <!-- Consider the limitless possibilities with our product team that has
          already tackled your cloud development obstacles. Seamlessly move more
          data and operations, reduce response times to a minimum cost, or scale
          your product for a large influx of new users. -->
          <!-- {{}} -->
          </div>
        <small class="fw-semibold text-muted" *ngIf="featuresList.length>0">Features & Amenities</small>
        <ul class="row">
          <li class="col-md-4" *ngFor="let feature of featuresList">{{ feature.name }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="row mb-5" *ngIf="displayView">
  <div class="col-lg-4">
    <div class="card card-flush h-lg-100">
      <!--begin::Header-->
      <div class="card-header pt-5">
        <!--begin::Title-->
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-dark">Agent Details</span>
        </h3>
        <!--end::Title-->
      </div>
      <!--end::Header-->

      <!--begin::Body-->
     <div class="card-body">
  <div class="d-flex flex-column gap-5">

    <!--begin::Agent with image-->
    <div
      class="d-flex flex-column gap-1"
      *ngIf="previewData?.agentName || previewData?.agentEmail"
    >
      <!-- <div class="fw-bold text-muted">Agent Info</div> -->
      <div class="d-flex justify-content-between align-items-start">
        <!-- Left side: name and email -->
        <div class="d-flex flex-column gap-3">
          <div *ngIf="previewData?.agentName">
            <div class="fw-bold text-muted">Name</div>
            <div class="fw-bold fs-5">{{ previewData?.agentName }}</div>
          </div>
          <div *ngIf="previewData?.agentEmail">
            <div class="fw-bold text-muted">Email</div>
            <div class="fw-bold fs-5">{{ previewData?.agentEmail }}</div>
          </div>
        </div>
      
        <!-- Right side: agent image -->
        <!-- Agent Image or Initials -->
        <div>
          <ng-container *ngIf="previewData?.agentImage; else initialsFallback">
            <img [src]="agentPhoto" alt="Agent" class="rounded-circle"
              style="width: 100px; height: 100px; object-fit: cover; margin-left: 1rem;" />
          </ng-container>
      
          <ng-template #initialsFallback>
            <div class="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold" [ngStyle]="{
              width: '100px',
              height: '100px',
              backgroundColor: '#6c757d',
              marginLeft: '1rem',
              fontSize: '32px'
            }">
              {{ getAgentInitials(previewData?.agentName) }}
            </div>
          </ng-template>
        </div>
      
      </div>
    </div>
    <!--end::Agent with image-->

    <!--begin::Agent phone-->
    <div
      class="d-flex flex-column gap-1"
      *ngIf="previewData?.agentPhone != null"
    >
      <div class="fw-bold text-muted">Mobile</div>
      <div class="fw-bold fs-5">{{ previewData?.agentPhone }}</div>
    </div>
    <!--end::Agent phone-->

    <!--begin::Agent about-->
    <div
      class="d-flex flex-column gap-1"
      *ngIf="previewData?.agentAbout != null"
    >
      <div class="fw-bold text-muted">About</div>
      <div class="fw fs-5">{{ previewData?.agentAbout }}</div>
    </div>
    <!--end::Agent about-->

    <!--begin::Agent languages-->
    <div
      class="d-flex flex-column gap-1"
      *ngIf="previewData?.agentSpeaks != null"
    >
      <div class="fw-bold text-muted">Speaks</div>
      <div class="fw-bold fs-5">{{ selectedLanguages.join(', ') }}</div>
    </div>
    <!--end::Agent languages-->

  </div>
</div>

      <!--end::Body-->
    </div>
  </div>

  <div class="col-lg-8">
    <div class="card card-flush h-lg-100">
      <!--begin::Body-->
      <div class="card-body" *ngIf="mapDisplay">
        <iframe
          *ngIf="displayView && mapLocation != ''"
          class="w-100 rounded"
          [src]="getMapLocation()"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
        <div class="fw-bold fs-5"> <span *ngIf="previewData?.subLocationName != null">{{ previewData?.subLocationName }}</span> <span *ngIf="previewData?.locationName != null">, {{ previewData?.locationName }}</span><span *ngIf="previewData?.emiratesName != null">, {{ previewData?.emiratesName }}</span></div>
      </div>
      <!--end::Body-->
    </div>
  </div>
</div>

<div class="row mt-25">
  <span>Powered by<a target="_blank" href="https://prophero.net/"><img class="ml-2 mr-2 logo-sticky h-20px h-lg-25px" src="../../../../assets/media/logos/prophero.svg"></a> <a class="link-hover" target="_blank" href="https://prophero.net/">(PropHero.net),</a> revolutionizing Real Estate CRM.</span>
</div>


<ng-template #photos>
  <form novalidate="" class="form">
  <div class="modal-content">
    <div class="modal-header py-3">
      <!--begin::Modal title-->
      <h4 class="m-0">Photos</h4>
      <!--end::Modal title-->
      <div
        class="btn btn-sm btn-icon btn-active-color-primary"
        (click)="closePhotos()"
      >
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
    </div>
    <div class="modal-body">
      <!--begin::Form-->
        <div class="row">
          <ngx-slick-carousel class="carousel p-35" 
                        #slickModal="slick-carousel" 
                        [config]="slideConfig" 
                        (init)="slickInit($event);"
                        (breakpoint)="breakpoint($event)"
                        (afterChange)="afterChange($event)"
                        (beforeChange)="beforeChange($event)">
          <div *ngFor="let slide of reOrderslides">  
          <div ngxSlickItem class="slide">
                  <img src="{{ slide }}" alt="" width="100%">
            </div>
          </div>
    </ngx-slick-carousel>
    
    <!-- <button (click)="addSlide()">Add</button>
    <button (click)="removeSlide()">Remove</button>
    <button (click)="slickModal.slickGoTo(2)">slickGoto 2</button>
    <button (click)="slickModal.unslick()">unslick</button> -->
        </div>
      
    </div>
    <!--end::Form-->
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-sm btn-primary"
        data-kt-menu-dismiss="true"
        (click)="closePhotos()"
      >
        Close
      </button>
    </div>
  </div>
  </form>
</ng-template>
